/* eslint-disable no-restricted-syntax -- framework */
import { inject, InjectionToken } from '@angular/core';
import { EffectWithIdentifier } from '@safarilaw-webapp/shared/redux';
import { SquirrelValue } from '../squirrel-value/models/app/squirrel-value';

import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { SQUIRREL_VALUE_REDUX_OBJECT_TOKEN } from './injectable-object-tokens';

export const getEffectTokens = () => [
  new InjectionToken<EffectWithIdentifier<SquirrelValue>>('SQUIRREL_VALUE_REDUX_EFFECT', {
    providedIn: 'root',
    factory: () => new EffectWithIdentifier<SquirrelValue>(inject(Store), inject(Actions), inject(SQUIRREL_VALUE_REDUX_OBJECT_TOKEN))
  })
  /*** BEWARE OF DOG - DO NOT DELETE OR PUT ANYTHING ELSE BELOW THIS ***/
];
